
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, endLoading } from "store/group-user";

interface ApiGroupUserRemoveInputProps {
    ids: number[]
}

type ApiGroupUserRemoveOutputProps = OutputBaseProps<{ item: GroupUserItemProps; }>

export const apiGroupUserRemove = async (data: ApiGroupUserRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiGroupUserRemoveOutputProps>("/api/group/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};